// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
// import { AuthProvider, useAuth } from "./components/AuthContext";
// import {
//   LayoutDashboard, HelpCircle, Mail, Send, MessageSquare,
//   FileText, FolderOpen, CreditCard, Settings, Clock
// } from 'lucide-react';
// import SmtpAccounts from "./components/SmtpAccounts";
// import SendEmail from "./components/SendEmail";
// import DatabasesPage from "./components/DatabasesPage";
// import ConversationsPage from "./components/ConversationsPage";
// import Catalog from './components/Catalog';
// import Login from './components/pages/Login';
// import Register from './components/pages/Register';
// import TelegramSettings from './components/TelegramSettings';
// import PricingPage from "./components/PricingPage";
// import BillingPage from "./components/BillingPage";
// import Dashboard from "./components/Dashboard";
// import Landing from './components/pages/Landing';
// import Terms from './components/pages/legal/Terms';
// import Privacy from './components/pages/legal/Privacy';
// import Cookies from './components/pages/legal/Cookies';
// import AntiSpam from './components/pages/legal/AntiSpam';
// import PaymentFail from './components/pages/PaymentFail';
// import VerifyEmail from './components/pages/VerifyEmail';
// import ForgotPassword from './components/pages/ForgotPassword';
// import ResetPassword from './components/pages/ResetPassword';
// import AdminPage from './components/AdminPage';
// import HelpPage from './components/pages/HelpPage';
// import TemplatesPage from "./components/TemplatesPage";
// import { Target } from "lucide-react";
// import LeadsPage from "./components/LeadsPage";
// import ModerationPage from "./components/ModerationPage";


// function Sidebar({ activePage, setActivePage, menuItems }) {
//   const { user, logout } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   return (
//     <div
//       className="sidebar"
//       style={{
//         borderRight: "1px solid #e5e7eb",
//         boxSizing: "border-box",
//         backgroundColor: "white",
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//         position: "fixed",
//         left: 0,
//         top: 0,
//         boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
//         zIndex: 100,
//         padding: "12px 4px",
//         width: "15vw",
//         minWidth: "56px",
//         maxWidth: "80px",
//       }}
//     >
//       <div style={{ marginBottom: "16px", textAlign: "center" }}>
//         <div style={{ fontSize: "16px", fontWeight: "bold", color: "#2563eb" }} className="sidebar-logo">
//           Mailora
//         </div>
//       </div>

//       <div style={{ flex: 1, overflowY: "auto" }}>
//         {menuItems.map(item => (
//           <div
//             key={item.id}
//             title={item.tooltip || item.label}
//             onClick={() => {
//               setActivePage(item.id);
//               navigate(`/${item.id}`);
//             }}
//             className="sidebar-item"
//             style={{
//               padding: "10px 4px",
//               marginBottom: "4px",
//               cursor: "pointer",
//               borderRadius: "8px",
//               textAlign: "center",
//               fontSize: "10px",
//               lineHeight: 1.2,
//               backgroundColor: activePage === item.id ? "#eff6ff" : "transparent",
//               color: activePage === item.id ? "#2563eb" : "#374151",
//               transition: "all 0.2s",
//               fontWeight: activePage === item.id ? "600" : "normal",
//               wordBreak: "break-word",
//             }}
//           >
//           <div style={{ marginBottom: "2px" }} className="sidebar-icon">
//             {item.icon}
//           </div>
//             <div className="sidebar-label">{item.label}</div>
//           </div>
//         ))}
//       </div>

//       <button
//         onClick={handleLogout}
//         className="sidebar-logout"
//         style={{
//           padding: "8px 4px",
//           marginTop: "12px",
//           backgroundColor: "#fee2e2",
//           color: "#ef4444",
//           border: "none",
//           borderRadius: "8px",
//           cursor: "pointer",
//           fontSize: "10px",
//           fontWeight: "500",
//         }}
//       >
//         Выйти
//       </button>
//     </div>
//   );
// }

// // Компонент защищенного контента
// function ProtectedContent() {
//   const [activePage, setActivePage] = useState("dashboard");
//   const { isAuthenticated, loading } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();

// const menuItems = [
//   { id: "dashboard", label: "Дашборд", icon: <LayoutDashboard size={18} />, tooltip: "Общая статистика по кампаниям" },
//   { id: "leads", label: "Лиды", icon: <Target size={18} />, tooltip: "CRM лидов" },
//   { id: "help", label: "Помощь", icon: <HelpCircle size={18} />, tooltip: "Инструкция по работе" },
//   { id: "smtp", label: "Почты", icon: <Mail size={18} />, tooltip: "Управление SMTP аккаунтами" },
//   { id: "massmail", label: "Рассылки", icon: <Send size={18} />, tooltip: "Создание и управление рассылками" },
//   { id: "conversations", label: "Переписки", icon: <MessageSquare size={18} />, tooltip: "История переписок" },
//   { id: "templates", label: "Шаблоны", icon: <FileText size={18} />, tooltip: "Шаблоны писем" },
//   { id: "catalog", label: "Каталог", icon: <FolderOpen size={18} />, tooltip: "Выбор аудитории" },
//   { id: "pricing", label: "Тарифы", icon: <CreditCard size={18} />, tooltip: "Выбор тарифа" },
//   { id: "settings", label: "Настройки", icon: <Settings size={18} />, tooltip: "Настройки приложения" },
//   { id: "moderation", label: "Модерация", icon: <Clock size={18} />, tooltip: "Проверка кампаний" },
// ];

//   // Синхронизируем activePage с текущим URL
//   useEffect(() => {
//     const path = location.pathname.replace('/', '');
//     if (path && menuItems.some(item => item.id === path)) {
//       setActivePage(path);
//     } else if (path === '') {
//       setActivePage('dashboard');
//     }
//   }, [location]);

//   if (loading) {
//     return (
//       <div style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//         marginLeft: "220px"
//       }}>
//         <div style={{
//           width: "50px",
//           height: "50px",
//           border: "4px solid #e5e7eb",
//           borderTopColor: "#2563eb",
//           borderRadius: "50%",
//           animation: "spin 1s linear infinite"
//         }} />
//         <style>{`
//           @keyframes spin {
//             to { transform: rotate(360deg); }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//     return (
//     <div style={{ minHeight: "100vh" }}>
//       <Sidebar
//         activePage={activePage}
//         setActivePage={setActivePage}
//         menuItems={menuItems}
//       />

//       <div
//         className="content"
//         style={{
//           padding: "16px",
//           overflowY: "auto",
//           backgroundColor: "#f9fafb",
//           minHeight: "100vh",
//         }}
//       >
//         <Routes>
//           <Route path="/admin" element={<AdminPage />} />
//           <Route path="/moderation" element={<ModerationPage />} />
//           <Route path="/help" element={<HelpPage />} />
//           <Route path="/leads" element={<LeadsPage />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/smtp" element={<SmtpAccounts />} />
//           <Route path="/massmail" element={<SendEmail />} />
//           <Route path="/conversations" element={<ConversationsPage />} />
//           <Route path="/catalog" element={<Catalog />} />
//           <Route path="/templates" element={<TemplatesPage />} />
//           <Route path="/pricing" element={<PricingPage />} />
//           <Route path="/settings" element={<TelegramSettings />} />
//           <Route path="/payment/fail" element={<PaymentFail />} />
//           <Route path="/" element={<Navigate to="/dashboard" replace />} />
//         </Routes>
//       </div>
//     </div>
//   );
// }

// function AppContent() {
//   return (
//     <Routes>
//       <Route path="/" element={<Landing />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/forgot-password" element={<ForgotPassword />} />
//       <Route path="/reset-password" element={<ResetPassword />} />
//       <Route path="/register" element={<Register />} />
//       <Route path="/verify-email" element={<VerifyEmail />} />
//       <Route path="/databases" element={<div>API route</div>} />

//       {/* Юридические документы — ДО /*, иначе перехватит ProtectedContent */}
//       <Route path={process.env.REACT_APP_LEGAL_TERMS_PATH        || '/terms'}        element={<Terms />} />
//       <Route path={process.env.REACT_APP_LEGAL_PRIVACY_PATH      || '/privacy'}      element={<Privacy />} />
//       <Route path={process.env.REACT_APP_LEGAL_COOKIES_PATH      || '/cookies'}      element={<Cookies />} />
//       <Route path={process.env.REACT_APP_LEGAL_ANTI_SPAM_PATH    || '/anti-spam'}    element={<AntiSpam />} />

//       {/* Всё остальное — приложение за авторизацией */}
//       <Route path="/*" element={<ProtectedContent />} />
//     </Routes>
//   );
// }

// // Корневой компонент с провайдерами
// export default function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <AppContent />
//       </AuthProvider>
//     </Router>
//   );
// }

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthContext";
import {
  LayoutDashboard, HelpCircle, Mail, Send, MessageSquare,
  FileText, FolderOpen, CreditCard, Settings, Clock
} from 'lucide-react';
import SmtpAccounts from "./components/SmtpAccounts";
import SendEmail from "./components/SendEmail";
import DatabasesPage from "./components/DatabasesPage";
import ConversationsPage from "./components/ConversationsPage";
import Catalog from './components/Catalog';
import Login from './components/pages/Login';
import Register from './components/pages/Register';
import TelegramSettings from './components/TelegramSettings';
import PricingPage from "./components/PricingPage";
import BillingPage from "./components/BillingPage";
import Dashboard from "./components/Dashboard";
import Landing from './components/pages/Landing';
import Terms from './components/pages/legal/Terms';
import Privacy from './components/pages/legal/Privacy';
import Cookies from './components/pages/legal/Cookies';
import AntiSpam from './components/pages/legal/AntiSpam';
import PaymentFail from './components/pages/PaymentFail';
import VerifyEmail from './components/pages/VerifyEmail';
import ForgotPassword from './components/pages/ForgotPassword';
import ResetPassword from './components/pages/ResetPassword';
import AdminPage from './components/AdminPage';
import HelpPage from './components/pages/HelpPage';
import TemplatesPage from "./components/TemplatesPage";
import { Target } from "lucide-react";
import LeadsPage from "./components/LeadsPage";
import ModerationPage from "./components/ModerationPage";


function Sidebar({ activePage, setActivePage, menuItems }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div
      className="sidebar"
      style={{
        borderRight: "1px solid #e5e7eb",
        boxSizing: "border-box",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
        zIndex: 100,
        padding: "12px 4px",
        width: "15vw",
        minWidth: "56px",
        maxWidth: "80px",
      }}
    >
      <div style={{ marginBottom: "16px", textAlign: "center" }}>
        <div style={{ fontSize: "16px", fontWeight: "bold", color: "#2563eb" }} className="sidebar-logo">
          Mailora
        </div>
      </div>

      <div style={{ flex: 1, overflowY: "auto" }}>
        {menuItems.map(item => (
          <div
            key={item.id}
            title={item.tooltip || item.label}
            onClick={() => {
              setActivePage(item.id);
              navigate(`/${item.id}`);
            }}
            className="sidebar-item"
            style={{
              padding: "10px 4px",
              marginBottom: "4px",
              cursor: "pointer",
              borderRadius: "8px",
              textAlign: "center",
              fontSize: "10px",
              lineHeight: 1.2,
              backgroundColor: activePage === item.id ? "#eff6ff" : "transparent",
              color: activePage === item.id ? "#2563eb" : "#374151",
              transition: "all 0.2s",
              fontWeight: activePage === item.id ? "600" : "normal",
              wordBreak: "break-word",
            }}
          >
          <div style={{ marginBottom: "2px" }} className="sidebar-icon">
            {item.icon}
          </div>
            <div className="sidebar-label">{item.label}</div>
          </div>
        ))}
      </div>

      <button
        onClick={handleLogout}
        className="sidebar-logout"
        style={{
          padding: "8px 4px",
          marginTop: "12px",
          backgroundColor: "#fee2e2",
          color: "#ef4444",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "10px",
          fontWeight: "500",
        }}
      >
        Выйти
      </button>
    </div>
  );
}

// Компонент защищенного контента
function ProtectedContent() {
  const [activePage, setActivePage] = useState("dashboard");
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const baseMenuItems = [
    { id: "dashboard",     label: "Дашборд",    icon: <LayoutDashboard size={18} />, tooltip: "Общая статистика по кампаниям" },
    { id: "leads",         label: "Лиды",       icon: <Target size={18} />,          tooltip: "CRM лидов" },
    { id: "help",          label: "Помощь",     icon: <HelpCircle size={18} />,      tooltip: "Инструкция по работе" },
    { id: "smtp",          label: "Почты",      icon: <Mail size={18} />,            tooltip: "Управление SMTP аккаунтами" },
    { id: "massmail",      label: "Рассылки",   icon: <Send size={18} />,            tooltip: "Создание и управление рассылками" },
    { id: "conversations", label: "Переписки",  icon: <MessageSquare size={18} />,   tooltip: "История переписок" },
    { id: "templates",     label: "Шаблоны",    icon: <FileText size={18} />,        tooltip: "Шаблоны писем" },
    { id: "catalog",       label: "Каталог",    icon: <FolderOpen size={18} />,      tooltip: "Выбор аудитории" },
    { id: "pricing",       label: "Тарифы",     icon: <CreditCard size={18} />,      tooltip: "Выбор тарифа" },
    { id: "settings",      label: "Настройки",  icon: <Settings size={18} />,        tooltip: "Настройки приложения" },
  ];

  const menuItems = [
    ...baseMenuItems,
    ...(user?.role === "admin"
      ? [{ id: "moderation", label: "Модерация", icon: <Clock size={18} />, tooltip: "Проверка кампаний" }]
      : []),
  ];

  // Синхронизируем activePage с текущим URL
  useEffect(() => {
    const path = location.pathname.replace('/', '');
    if (path && menuItems.some(item => item.id === path)) {
      setActivePage(path);
    } else if (path === '') {
      setActivePage('dashboard');
    }
  }, [location]);

  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        marginLeft: "220px"
      }}>
        <div style={{
          width: "50px",
          height: "50px",
          border: "4px solid #e5e7eb",
          borderTopColor: "#2563eb",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ minHeight: "100vh" }}>
      <Sidebar
        activePage={activePage}
        setActivePage={setActivePage}
        menuItems={menuItems}
      />

      <div
        className="content"
        style={{
          padding: "16px",
          overflowY: "auto",
          backgroundColor: "#f9fafb",
          minHeight: "100vh",
        }}
      >
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route
            path="/moderation"
            element={
              user?.role === "admin"
                ? <ModerationPage />
                : <Navigate to="/dashboard" replace />
            }
          />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/smtp" element={<SmtpAccounts />} />
          <Route path="/massmail" element={<SendEmail />} />
          <Route path="/conversations" element={<ConversationsPage />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/settings" element={<TelegramSettings />} />
          <Route path="/payment/fail" element={<PaymentFail />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/databases" element={<div>API route</div>} />

      {/* Юридические документы — ДО /*, иначе перехватит ProtectedContent */}
      <Route path={process.env.REACT_APP_LEGAL_TERMS_PATH        || '/terms'}        element={<Terms />} />
      <Route path={process.env.REACT_APP_LEGAL_PRIVACY_PATH      || '/privacy'}      element={<Privacy />} />
      <Route path={process.env.REACT_APP_LEGAL_COOKIES_PATH      || '/cookies'}      element={<Cookies />} />
      <Route path={process.env.REACT_APP_LEGAL_ANTI_SPAM_PATH    || '/anti-spam'}    element={<AntiSpam />} />

      {/* Всё остальное — приложение за авторизацией */}
      <Route path="/*" element={<ProtectedContent />} />
    </Routes>
  );
}

// Корневой компонент с провайдерами
export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}